<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Pareto forgalmi kimutatás</span>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="pareto/fetchAll"
      />
      <el-button
        style="float: right; margin-top: -90px;"
        :loading="downloadLoading"
        icon="el-icon-download"
        @click="download"
      >
        Letöltés
      </el-button>
    </div>
    <chart/>
    <pareto-list style="margin-top: 30px" :defaultFilterString="defaultFilterString"/>
  </el-card>
</template>

<script>
import Chart from '../../components/reports/pareto/Chart';
import ParetoList from '../../components/reports/pareto/List';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    Chart,
    ParetoList,
    TableFilter,
  },
  data() {
    return {
      downloadLoading: false,
      loading: false,
      filterConfig: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  computed: {
    defaultDeliveryDateRange () {
      const now = new Date
      const from = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7)
      const to = new Date(now.getFullYear(), now.getMonth(), now.getDate())

      return [
        from.toISOString().split('T')[0],
        to.toISOString().split('T')[0],
      ]
    },
    defaultFilterString () {
      return 'delivery_date=' + this.defaultDeliveryDateRange.join(',')
    }
  },
  methods: {
    async download() {
      this.downloadLoading = true;
      try {
        const excel = await axios({
          url: `api/reports/pareto/download`,
          method: 'POST',
          responseType: 'blob',
          data: this.$store.getters['pareto/filterString'],
        });
        saveAs(excel, `pareto.xlsx`);
      } catch (e) {}
      this.downloadLoading = false;
    },
    async setConfig() {
      let users = this.$store.getters['user/users'];
      if (!users.length) {
        await this.$store.dispatch('user/fetchAll');
        users = this.$store.getters['user/users'];
      }
      let locations = this.$store.getters['location/locations'];
      if (!locations.length) {
        await this.$store.dispatch('location/fetchAll');
        locations = this.$store.getters['location/locations'];
      }
      this.filterConfig = [
        {
          type: 'select',
          options: users,
          name: 'representative_user',
          label: 'Képviselő',
          labelCallback: user => user && user.last_name + ' ' + user.first_name || '',
          valueKey: 'id',
        },
        {
          type: 'dateRange',
          name: 'delivery_date',
          label: 'Időszak',
          defaultSearch: true,
          filterInput: this.defaultDeliveryDateRange,
        },
        {
          type: 'remote',
          name: 'customer',
          label: 'Partner',
          labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'partner/search',
        },
        {
          type: 'remote',
          name: 'shop_id',
          label: 'Üzlet',
          labelCallback: shop => shop && `#${shop.id} ${shop.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'shop/search',
        },
        {
          type: 'select',
          options: locations,
          name: 'location',
          label: 'Terület',
          labelCallback: location => location && location.value || '',
          valueKey: 'id',
        },
      ];
    }
  }
};
</script>
